import type { ReactElement } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import type { Currency } from '@swf/core/enums';
import type { FormatAsCurrency } from '@swf/core/hooks/useCurrencyFormatter';
import useCurrencyFormatter from '@swf/core/hooks/useCurrencyFormatter';
import { select } from '@swf/core/store';

export interface Props {
  currency?: Currency;
  className?: string;
  hideSame?: boolean;
  trimSpace?: boolean;
}

export const getCurrencySymbol = ({
  formatAsCurrency,
  currency
}: {
  formatAsCurrency: FormatAsCurrency;
  currency: Currency;
}) => formatAsCurrency({ value: 0, currency }).replace(new RegExp("[0-9,.']", 'g'), '');

const CurrencySymbol: React.FC<Props> = ({
  currency: propsCurrency,
  className,
  hideSame = false,
  trimSpace
}) => {
  const formatAsCurrency = useCurrencyFormatter();
  const realMoneyCurrency = useSelector(select.currency.getRealMoney);
  const currency = propsCurrency || realMoneyCurrency;
  const formattedSymbol = getCurrencySymbol({ formatAsCurrency, currency });
  const result = trimSpace ? formattedSymbol.trim() : formattedSymbol;

  if (!currency || (result.startsWith(currency) && hideSame)) {
    return null;
  }

  return className ? (
    <span className={className}>{result}</span>
  ) : (
    (result as unknown as ReactElement)
  );
};

export default CurrencySymbol;
